import cx from 'classnames';

import { getSearchResultsURL } from '../../utils/getSearchResultsURL';

import styles from './ColorTag.module.less';

export type ColorTagProps = {
  color: string;
  classes?: string;
  onClick?: () => void;
  slug?: string;
  component?: string;
};

export const ColorTag = ({
  color,
  classes,
  onClick,
  slug,
  component: Component = 'a',
}: ColorTagProps): JSX.Element => {
  if (Component === 'a') {
    return (
      <Component href={getSearchResultsURL(slug)}>
        <div
          className={cx(styles.container, classes)}
          style={{ backgroundColor: color }}
          data-testid="ColorTag"
        />
      </Component>
    );
  }

  return (
    <div
      role="button"
      className={cx(styles.container, classes)}
      style={{ backgroundColor: color }}
      data-testid="ColorTag"
      onClick={onClick}
    />
  );
};

export default ColorTag;
